// extracted by mini-css-extract-plugin
export var colorSquare = "_pj-0";
export var danger = "_pj-5";
export var lightPink = "_pj-8";
export var neutralBlue = "_pj-7";
export var neutralYellow = "_pj-6";
export var normal = "_pj-1";
export var primary = "_pj-2";
export var primaryLight = "_pj-3";
export var solidBlack = "_pj-g";
export var solidGreen = "_pj-b";
export var solidLightBlue = "_pj-d";
export var solidNavy = "_pj-c";
export var solidOrange = "_pj-f";
export var solidPink = "_pj-e";
export var solidRed = "_pj-9";
export var solidYellow = "_pj-a";
export var success = "_pj-4";